module.exports = __webpack_public_path__ + "static/media/forgot-background.668f66dc.jpg";